import glamorous from 'glamorous';
import { BrandonGrotesque } from 'module/View/Common';

export const Title = glamorous.h3({
  fontSize: '3rem',
  fontFamily: BrandonGrotesque.regular,
  fontStyle: 'normal',
  fontWeight: 'normal',
});

export const GoHomeLink = glamorous.a({});



// WEBPACK FOOTER //
// ./src/module/View/Main/NotFound/NotFound.s.ts